<template>
    <div>
        <b-modal
            ref="modalFiltersForm"
            hide-footer
            size="lg"
            no-overflow
            hide-no-focus="true"
            no-close-on-backdrop
            hide-header-close
            hide-header
            >
            <div class="title-modal">
                <div class="title-text-modal">
                    <FilterIcon style="margin-top: -3px;" class="mr-1"/>
                    <span>
                        Filtros
                    </span>
                </div>
                <div
                    class="float-right btn-hover-modal"
                    @click="closeFiltersForm()"
                >
                    <xIcon/>
                </div>
            </div>
            <div class="filters-form-lg content-card mb-3 mt-5">
                <div>
					<!-- <div v-if="showOptionsfilter.includes('rapid_filters')" class="mt-3 mb-2 filters-section-seconds">
                        <span>Filtros Rápidos</span>
                    </div> -->
                    <b-row
                        v-if="showOptionsfilter.includes('rapid_filters')"
                        class="filters-section-seconds pt-3"
                        style="justify-content: space-around; "
                    >
                        <div v-for="(option, idx) in optionsFiltersRapid" :key="idx" class="filter-item" style="justify-content: center;">
                            <button
                                v-bind:class="option.selected ? 'btn-rapid-filter-selected' : 'btn-rapid-filter'"
                                @click="handleOptionFilter(idx)"
                            >
                                {{ option.text }}
                            </button>
                        </div>
                    </b-row>
					<div class="mt-3 filters-section-seconds label-text" style="text-align: center;">
						<button
							class="btn-advanced-filter"
							@click="handleFilterAdvanced()"
						>
							Opções Avançadas de Filtro
							<ArrowUpIcon v-if="showFiltersAdvanced" style="height: 1rem;" />
							<ArrowDownIcon v-else style="height: 1rem;" />
						</button>
					</div>
					<div v-if="showFiltersAdvanced" class="mb-5">
						<b-row
							v-if="showOptionsfilter.includes('customer') || showOptionsfilter.includes('account') || showOptionsfilter.includes('category') || showOptionsfilter.includes('transaction_type') || showOptionsfilter.includes('grouping')"
							class="filters-orientation filters-section"
						>
							<b-col v-if="showOptionsfilter.includes('customer')" class="filter-item">
								<label>Clientes</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									:disabled="loading"
									v-model="selectedCustomer"
									search
									searchPlaceholder="Pesquisar"
									:options="{ multi: true, labelName: 'text' }"
									:selectOptions="optionsCustomer"
									:btnLabel="() => (selectedCustomer.length > 1 ? `${selectedCustomer[0].text}...` : selectedCustomer[0] && selectedCustomer[0].text) || 'Selecione'"
								/>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('account')" class="filter-item">
								<label>Contas</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									:disabled="loading"
									v-model="selectedAccount"
									search
									searchPlaceholder="Pesquisar"
									:options="{ multi: true, labelName: 'text' }"
									:selectOptions="optionsAccount"
									:btnLabel="() => (selectedAccount.length > 1 ? `${selectedAccount[0].text}...` : selectedAccount[0] && selectedAccount[0].text) || 'Selecione'"
								/>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('category')" class="filter-item">
								<label>Categoria das Transações</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									:disabled="loading"
									v-model="selectedCategory"
									search
									searchPlaceholder="Pesquisar"
									:options="{ multi: true, labelName: 'text' }"
									:selectOptions="optionsCategory"
									:btnLabel="() => (selectedCategory.length > 1 ? `${selectedCategory[0].text}...` : selectedCategory[0] && selectedCategory[0].text) || 'Selecione'"
								/>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('grouping')" class="filter-item">
								<label>Agrupamento</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									v-model="selectedGrouping"
									:options="{ multi: false, labelName: 'nome' }"
									:selectOptions="optionsGrouping"
									data-cy="status"
									:btnLabel="() => (selectedGrouping.length > 1 ? `${selectedGrouping[0].nome}...` : selectedGrouping[0] && selectedGrouping[0].nome) || 'Selecione'"
								/>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('transaction_type')" class="filter-item">
								<label>Tipo de Transação</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									:disabled="loading"
									v-model="selectedTransactionType"
									searchPlaceholder="Pesquisar"
									:options="{ multi: true, labelName: 'text' }"
									:selectOptions="transactionTypeOptions"
									:btnLabel="() => (selectedTransactionType.length > 1 ? `${selectedTransactionType[0].text}...` : selectedTransactionType[0] && selectedTransactionType[0].text) || 'Selecione'"
								/>
							</b-col>
						</b-row>
						<b-row
							v-if="showOptionsfilter.includes('initial_date') || showOptionsfilter.includes('end_date') || showOptionsfilter.includes('type_search_date') || showOptionsfilter.includes('status')"
							class="filters-orientation filters-section-seconds"
						>
							<b-col v-if="showOptionsfilter.includes('initial_date')" class="filter-item">
								<label>Data inicial</label>
								<div class="d-flex">
									<datepicker
										name="startDate"
										class="w-100"
										placeholder="Início"
										id="data-inicial-historica"
										input-class="bg-white"
										v-model="initDate"
										:format="formatter"
										:language="ptBR"
										:bootstrap-styling="true"
										@input="validateDateSearch"
										:value-as-date="false"
									/>
								</div>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('end_date')" class="filter-item">
								<label>Data final</label>
								<div class="d-flex">
									<datepicker
										name="endDate"
										class="w-100"
										placeholder="endDate"
										id="data-final-historica"
										input-class="bg-white"
										v-model="endDate"
										:format="formatter"
										:language="ptBR"
										:bootstrap-styling="true"
										@input="validateDateSearch"
										:value-as-date="false"
									/>
								</div>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('type_search_date')" class="filter-item">
								<label>
									Data da pesquisa
								</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									:disabled="loading"
									v-model="selectedDateSearch"
									searchPlaceholder="Pesquisar"
									:options="{ multi: false, labelName: 'text' }"
									:selectOptions="selectDateSearch"
									:btnLabel="() => (selectedDateSearch.length > 1 ? `${selectedDateSearch[0].text}...` : selectedDateSearch[0] && selectedDateSearch[0].text) || 'Selecione'"
								/>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('status')" class="filter-item">
								<label>
									Estado
								</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									:disabled="loading"
									v-model="selectedStatusTransaction"
									searchPlaceholder="Pesquisar"
									:options="{ multi: true, labelName: 'text' }"
									:selectOptions="selectStatusTransaction"
									:btnLabel="() => (selectedStatusTransaction.length > 1 ? `${selectedStatusTransaction[0].text}...` : selectedStatusTransaction[0] && selectedStatusTransaction[0].text) || 'Selecione'"
								/>
							</b-col>
						</b-row>
						<b-row
							v-if="showOptionsfilter.includes('comments') || showOptionsfilter.includes('reference')"
							class="filters-orientation filters-section-seconds mt-3"
						>
							<b-col v-if="showOptionsfilter.includes('reference')" class="filter-item">
								<label>
									Referência
								</label>
								<input
									id="reference"
									class="form-control time-pick"
									v-model="reference"
								/>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('comments')" class="filter-item">
								<label>
									Observações
								</label>
								<input
									id="comments"
									class="form-control time-pick"
									v-model="comments"
								/>
							</b-col>
						</b-row>
						<b-row
							v-if="showOptionsfilter.includes('year') || showOptionsfilter.includes('type') || showOptionsfilter.includes('month')"
								class="filters-orientation filters-section-seconds mt-3"
						>
							<b-col v-if="showOptionsfilter.includes('month')" class="filter-item">
								<label>Meses</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									v-model="selectedMonths"
									:options="{ multi: true, labelName: 'nome' }"
									:selectOptions="optionsMonths"
									data-cy="status"
									:btnLabel="() => (selectedMonths.length > 1 ? `${selectedMonths[0].nome}...` : selectedMonths[0] && selectedMonths[0].nome) || 'Selecione'"
								/>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('year')" class="filter-item">
								<label>Ano</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									v-model="selectedYears"
									:options="{ multi: false, labelName: 'nome' }"
									:selectOptions="optionsYears"
									data-cy="status"
									:btnLabel="() => (selectedYears.length > 1 ? `${selectedYears[0].nome}...` : selectedYears[0] && selectedYears[0].nome) || 'Selecione'"
								/>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('type')" class="filter-item">
								<label>Tipo Gráfico</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									v-model="selectedTypeChart"
									:options="{ multi: false, labelName: 'nome' }"
									:selectOptions="optionsTypeChart"
									data-cy="status"
									:btnLabel="() => (selectedTypeChart.length > 1 ? `${selectedTypeChart[0].nome}...` : selectedTypeChart[0] && selectedTypeChart[0].nome) || 'Selecione'"
								/>
							</b-col>
						</b-row>
						<b-row
							v-if="showOptionsfilter.includes('product') || showOptionsfilter.includes('productClass') || showOptionsfilter.includes('quantity')"
								class="filters-orientation filters-section-seconds mt-3"
						>
							<b-col v-if="showOptionsfilter.includes('product')" class="filter-item">
								<label>Produto</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									v-model="selectedProduct"
									:options="{ multi: true, labelName: 'nome' }"
									:selectOptions="optionsProduct"
									search
									searchPlaceholder="Pesquisar"
									data-cy="status"
									:btnLabel="() => (selectedProduct.length > 1 ? `${selectedProduct[0].nome}...` : selectedProduct[0] && selectedProduct[0].nome) || 'Selecione'"
								/>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('product_class')" class="filter-item">
								<label>Tipo Produto</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									v-model="selectedProductClass"
									:options="{ multi: true, labelName: 'nome' }"
									search
									searchPlaceholder="Pesquisar"
									:selectOptions="optionsProductClass"
									data-cy="status"
									:btnLabel="() => (selectedProductClass.length > 1 ? `${selectedProductClass[0].nome}...` : selectedProductClass[0] && selectedProductClass[0].nome) || 'Selecione'"
								/>
							</b-col>
							<b-col v-if="showOptionsfilter.includes('quantity')" class="filter-item">
								<label>Com Estoque</label>
								<vue-multi-select
									class="multi-100 mb-1 style-select"
									v-model="selectedQuantity"
									:options="{ multi: false, labelName: 'nome' }"
									:selectOptions="optionsQuantity"
									data-cy="status"
									:btnLabel="() => (selectedQuantity.length > 1 ? `${selectedQuantity[0].nome}...` : selectedQuantity[0] && selectedQuantity[0].nome) || 'Selecione'"
								/>
							</b-col>
						</b-row>
					</div>
					<div class="mt-4 search-button" @click="findRecords()">
                        <SearchIcon/>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import Datepicker from "vuejs-datepicker";
	import { ptBR } from "vuejs-datepicker/dist/locale";
	import { AccountService } from "../../services/account";
	import { TransactionService } from "../../services/transaction";
	import { CategoryExpensesService } from "../../services/categoryExpenses";

	export default {
		name: "Filters",
		components: {
			Datepicker
		},

		props: {
			showOptionsfilter: {
				type: Array,
				required: false
			},
			loading: {
				type: Boolean,
				default: false
			},
			showFiltersForm: {
				type: Boolean,
				default: false
			},
			optionsAccount: {
				type: Array,
				required: false,
				default: () => []
			},
			optionsCategory: {
				type: Array,
				required: false,
				default: () => []
			},
			optionsCustomer: {
				type: Array,
				required: false,
				default: () => []
			},
			defaultFilterRapid: {
				type: Number,
				required: false,
				default: 1
			},
			expandedAdvancedFilters: {
				type: Boolean,
				required: false,
				default: false
			},
			optionsProduct: {
				type: Array,
				required: false,
				default: () => []
			},
			optionsProductClass: {
				type: Array,
				required: false,
				default: () => []
			}
		},
		data () {
			return {
				ptBR,
				accountService: new AccountService(),
				transactionService: new TransactionService(),
				categoryService: new CategoryExpensesService(),

				transactionTypeOptions: [
					{
						text: "Entradas",
						value: "INCOME"
					},
					{
						text: "Saídas",
						value: "EXPENSES"
					},
					{
						text: "Transferências",
						value: "TRANSFER"
					},
					{
						text: "Conta a Pagar",
						value: "TOPAY"
					},
					{
						text: "Contas a Receber",
						value: "TORECEIVE"
					},
					{
						text: "Agendamentos Recurrente",
						value: "RECURRING"
					}
				],

				// filters
				selectedCategory: [],
				selectedStatusTransaction: [],
				selectedDateSearch: [
					{ text: "Lançamento", value: 0 }
				],
				selectStatusTransaction: [
					{ text: "Em aberto", value: 0 },
					{ text: "Pagos", value: 1 },
					{ text: "Cancelados", value: 2 }
				],
				selectDateSearch: [
					{ text: "Lançamento", value: 0},
					{ text: "Vencimento", value: 1},
					{ text: "Pagamento", value: 2}
				],
				selectedAccount: [],
				selectedCustomer: [],
				initDate: null,
				endDate: null,
				comments: "",
				reference: "",
				selectedTransactionType: [],

				optionsFiltersRapid: [
					{
						value: 1,
						text: "Mês anterior",
						selected: false
					},
					{
						value: 2,
						text: "Últimos 15 dias",
						selected: false
					},
					{
						value: 3,
						text: "Últimos 7 dias",
						selected: false
					},
					{
						value: 4,
						text: "Ontem",
						selected: false
					},
					{
						value: 5,
						text: "Hoje",
						selected: false
					},
					{
						value: 6,
						text: "Mês atual",
						selected: false
					},
					{
						value: 7,
						text: "Todas as Datas",
						selected: false
					}


				],
				filtersSelected: {},
				optionModalCategory: [],
				showFiltersAdvanced: false,

				// Filters Charts
				optionsMonths: [
					{
						nome: "Janeiro",
						value: 1
					}, {
						nome: "Fevereiro",
						value: 2
					}, {
						nome: "Março",
						value: 3
					}, {
						nome: "Abril",
						value: 4
					}, {
						nome: "Maio",
						value: 5
					}, {
						nome: "Junho",
						value: 6
					}, {
						nome: "Julho",
						value: 7
					}, {
						nome: "Agosto",
						value: 8
					}, {
						nome: "Setembro",
						value: 9
					}, {
						nome: "Outubro",
						value: 10
					}, {
						nome: "Novembro",
						value: 11
					}, {
						nome: "Dezembro",
						value: 12
					}
				],
				optionsYears: [],
				optionsGrouping: [
					{
						nome: "Categoria",
						value: 1
					}, {
						nome: "Mes e Ano",
						value: 2
					}
				],
				optionsTypeChart: [
					{
						nome: "Barra",
						value: "bar"
					}, {
						nome: "Linha",
						value: "line"
					}
				],
				selectedTypeChart: [],
				selectedMonths: [],
				selectedGrouping: [],
				selectedYears: [],

				optionsQuantity: [
					{
						nome: "Sim",
						value: 1
					}, {
						nome: "Não",
						value: 2
					}, {
						nome: "Todos",
						value: 3
					}
				],
				selectedQuantity: [
					{
						nome: "Todos",
						value: 3
					}
				],
				selectedProduct: [],
				selectedProductClass: []
			};
		},

		watch: {
			showFiltersForm () {
				if (this.showFiltersForm)
					this.$refs.modalFiltersForm.show();
				else
					this.$refs.modalFiltersForm.hide();
			}
		},

		mounted () {
			this.showFiltersAdvanced = this.expandedAdvancedFilters;
			this.getOptionsChart();
			this.handleOptionFilter(this.defaultFilterRapid);
			this.findRecords();
		},

		methods: {
			formatter (date) {
				return dayjs(date).locale("pt-br").format("D [de] MMMM [de] YYYY");
			},

			closeFiltersForm () {
				this.$emit("clickClose", true);
			},

			findRecords () {
				this.filtersSelected = {
					initDate: this.initDate ? dayjs(this.initDate).locale("pt-br").format("YYYY-MM-DD") : null,
					endDate: this.endDate ? dayjs(this.endDate).locale("pt-br").format("YYYY-MM-DD") : null,
					idsAccount: this.selectedAccount.map((ele) => ({value: ele.value})),
					comments: this.comments,
					transactionType: this.selectedTransactionType.map(type => type.value),
					idsCategory: this.selectedCategory.map((ele) => ({value: ele.value})),
					status: this.selectedStatusTransaction,
					reference: this.reference,
					dateSearch: this.selectedDateSearch,
					idsCustomer: this.selectedCustomer.map((ele) => ({value: ele.value})),
					monthsSelected: this.selectedMonths,
					yearsSelected: this.selectedYears,
					groupingSelected: this.selectedGrouping,
					typeChartSelected: this.selectedTypeChart,
					idsProduct: this.selectedProduct.map((ele) => ({value: ele.value})),
					idsProductClass: this.selectedProductClass.map((ele) => ({value: ele.value})),
					quantity: this.selectedQuantity.map((ele) => ({value: ele.value}))
				};
				this.$emit("clickSearch", this.filtersSelected);
			},

			handleOptionFilter (idxSelected) {
				const date = new Date();
				const value = this.optionsFiltersRapid[idxSelected].value;

				this.optionsFiltersRapid.forEach((option, idx) => {
					if (idx === idxSelected) {
						option.selected = true;
					} else {
						option.selected = false;
					}

					switch (value) {
						case 1:
							this.endDate = new Date();
							this.endDate.setDate("1");
							this.endDate.setDate(this.endDate.getDate() - 1);
							this.initDate = new Date(this.endDate);
							this.initDate.setDate("1");
							break;
						case 2:
							this.endDate = new Date(date);
							this.initDate = new Date(date);
							this.initDate.setDate(this.initDate.getDate() - 14);
							break;
						case 3:
							this.endDate = new Date(date);
							this.initDate = new Date(date);
							this.initDate.setDate(this.initDate.getDate() - 6);
							break;
						case 4:
							this.endDate = new Date(date);
							this.endDate.setDate(date.getDate() - 1);
							this.initDate = new Date(this.endDate);
							break;
						case 5:
							this.endDate = new Date(date);
							this.initDate = new Date(date);
							break;
						case 6:
							this.setFilterCurrentMonth();
							break;
						case 7:
							this.endDate = null;
							this.initDate = null;
							break;
					}
				});
			},

			setFilterCurrentMonth () {
				const endDate = new Date();
				const month = endDate.getMonth();
				const year = endDate.getFullYear();
				const ultimoDiaMes = new Date(year, month + 1, 0).getDate();
				endDate.setDate(ultimoDiaMes);
				const initDate = new Date();
				initDate.setDate("1");
				this.initDate = initDate;
				this.endDate = endDate;
			},

			validateDateSearch () {
				if (!this.initDate || !this.endDate) return;

				if (this.endDate >= this.initDate) {
					this.validateChangeDateFilter();
				} else {
					this.endDate = new Date(this.initDate);
					this.validateChangeDateFilter();
					// this.handleOptionFilter(4);
				}
			},

			validateChangeDateFilter () {
				this.optionsFiltersRapid.forEach(option => {
					option.selected = false;
				});
			},

			handleFilterAdvanced () {
				this.showFiltersAdvanced = !this.showFiltersAdvanced;
			},

			getOptionsChart () {
				const lastYear = (new Date().getFullYear() + 10);
				for (let year = 2020; year <= lastYear; year++) {
					this.optionsYears.push({
						nome: year.toString(),
						value: year.toString()
					});
				}
				const currentYear = ((new Date()).getFullYear()).toString();
				this.selectedYears = [{ nome: currentYear, value: currentYear }];
				this.selectedGrouping = [{ nome: "Categoria", value: 1 }];
				this.selectedTypeChart = [{ nome: "Barra", value: "bar" }];
			}
		}
	};
</script>